import React from 'react';
import { FormikInput as Input } from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';

export const DateOfBirht: React.FC = () => {
  const { t } = useTranslator();

  return (
    <>
      <h2 className="mb-4 title-large semi-bold">{t('app.biometric.birthDate.headline')}</h2>

      <Input
        name="dateOfBirth"
        type="date"
        label=""
        text={t('biometric.birthDate.description')}
        translateErrMsg
      />
    </>
  );
};

export default DateOfBirht;
